export default __webpack_public_path__ + "static/media/oldPatient.a28199ab.svg";